// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
/**
 * @hidden
 */
var GridDetailRowVue2 = {
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    return null;
  }
};
/**
 * @hidden
 */
var GridDetailRow = GridDetailRowVue2;
export { GridDetailRow, GridDetailRowVue2 };